export default __webpack_public_path__ + "b3d1c90a33f5d225f006a5cff7452f3a.png";